import { useEffect, useState } from "react";
import { X } from "lucide-react";

export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("cookie-consent")) setVisible(true);
  }, []);

  if (!visible) return null;

  const aceptar = () => {
    localStorage.setItem("cookie-consent", "1");
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-notice"
      className="fixed inset-x-4 bottom-20 z-50 mx-auto max-w-xl rounded-2xl border border-[#22304D] bg-[#131D33] p-5 shadow-[0_16px_60px_rgba(0,0,0,0.5)] md:bottom-4"
      role="dialog"
      aria-label="Aviso de cookies"
    >
      <div className="flex items-start gap-4">
        <p className="flex-1 text-xs leading-relaxed text-[#9AA6BE]">
          Utilizamos cookies propias y de análisis para mejorar tu experiencia.
          Puedes obtener más información en nuestra{" "}
          <a href="#" className="font-medium text-[#8B7CF6] underline">
            política de cookies
          </a>
          .
        </p>
        <button
          onClick={() => setVisible(false)}
          aria-label="Cerrar aviso de cookies"
          className="shrink-0 text-[#6B7690] transition-colors hover:text-[#F5F1EA]"
        >
          <X className="h-4 w-4" strokeWidth={1.5} />
        </button>
      </div>
      <button
        data-testid="cookie-accept-button"
        onClick={aceptar}
        className="mt-4 w-full rounded-full bg-gradient-to-r from-[#7C6CF0] to-[#6D8DFF] px-5 py-2.5 text-sm font-bold text-white transition-opacity hover:opacity-90"
      >
        Aceptar
      </button>
    </div>
  );
};
